import { SafeUrl } from '@angular/platform-browser';

import { Observable } from 'rxjs';

import { BarActionButtonType } from './bar-action-button-type.enum';
import { BarIcon } from '../shared/bar-icon.model';

/** @deprecated Use BaasLink within &lt;baas-layout&gt; with OnPush change detection.
 * Represents a button to be placed in the action BAR.
 */
// NOTE that we use delegates to mimic computed properties.
export class BarActionButtonOptions {
    /** Content in link */
    content?: Observable<any> | Promise<any> | any | (() => any);
    /** Click or tap action event */
    action?: (event?: any) => any;
    /** Router link */
    routerLink?: any[] | (() => any[]);
    /** Router URL */
    routerUrl?: string | (() => string);
    /** Disabled or enabled link */
    disabled?: boolean | (() => boolean);
    /** Hidden or visible link */
    hidden?: boolean | (() => boolean);
    /** Title aka tooltip */
    title?: Observable<any> | Promise<any> | any | (() => any);
    /** Link */
    href?: string | (() => string) | SafeUrl | (() => SafeUrl);
    /** Link target */
    target?: string;
    /** icon */
    icon?: BarIcon;
    /** Badge on the button, this can countain a counter */
    counter?: Observable<number> | Promise<number> | number | (() => number);
    /** Option type of the button (mat-stroked-button,...) */
    type?: BarActionButtonType;
    /** Material color. */
    color?: string;
}
